import { io, Socket } from 'socket.io-client';
export const REACT_APP_CHARGE_STATION_SOCKET = process.env.REACT_APP_CHARGE_STATION_SOCKET || window.location.origin;
export const socket: Socket = io(REACT_APP_CHARGE_STATION_SOCKET, {
  transports: ['websocket'],
  autoConnect: true,
  reconnection: true,
});

